import React, { useState } from 'react';
import TopBar from '../../components/TopBar.jsx';
import {
  Phone,
  ShieldCheck,
  Briefcase,
} from 'lucide-react';
import BusinessProfile from './components/tabs/BusinessProfile.jsx';
import Compliance from './components/tabs/Compliance.jsx';
import NumbersWizard from './components/NumbersWizard.jsx';

const TABS = [
  { id: 'numbers', label: 'Phone Numbers', icon: Phone },
  { id: 'profile', label: 'Business Profile', icon: Briefcase },
  { id: 'compliance', label: 'Compliance', icon: ShieldCheck },
];

/**
 * Phone Setup page — tab shell for numbers, business profile and compliance.
 * @returns {JSX.Element}
 */
export default function PhoneSetup() {
  const [tab, setTab] = useState('numbers');
  return (
    <div className="space-y-4">
      <TopBar title="Phone Setup" subtitle="Communications" />
      <div className="panel p-1 inline-flex gap-1">
        {TABS.map((t) => {
          const Icon = t.icon;
          return (
            <button
              key={t.id}
              onClick={() => setTab(t.id)}
              className={`px-4 py-2 rounded-md text-sm flex items-center gap-2 transition ${
                tab === t.id ? 'bg-civix-purple/25 text-white border border-civix-purple/50' : 'text-white/60 hover:text-white'
              }`}
            >
              <Icon className="w-4 h-4" /> {t.label}
            </button>
          );
        })}
      </div>
      {tab === 'numbers' && <NumbersWizard />}
      {tab === 'profile' && <BusinessProfile />}
      {tab === 'compliance' && <Compliance />}
    </div>
  );
}
